export const siteSearchLoading =  ({store})  => store.siteSearchReducer.loading;

export const siteSearchError =  ({store})  => store.siteSearchReducer.error;

export const siteSearchData =  ({store})  => store.siteSearchReducer.data;